import React from "react";
import { formatDate } from "../../service/constants";

const DischargeSummaryTextDetails = ({ dischargeDetailData }) => {
  return (
    <div
      className="info-container"
      style={{ height: "300px", overflowY: "auto" }}
    >
      <div>
        <span className="label">Discharge Date and Time - </span>
        {formatDate(dischargeDetailData.resource.date)}
      </div>
      <div>
        <div>
          <span className="label">Patient Name - </span>
          {dischargeDetailData.resource.subject.display}
        </div>
      </div>

      <div>
        <span className="label">Doctor Name - </span>
        {dischargeDetailData.resource.author[0].display}
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        {dischargeDetailData.resource.section.map((item) => (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              fontWeight: "bold",
            }}
          >
            {item.title}
            {item.code && (
              <span style={{ fontWeight: "normal" }}>{item.code.text}</span>
            )}
            {item.entry && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {item.entry.map((item) => (
                  <span style={{ fontWeight: "normal" }}>{item.display}</span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DischargeSummaryTextDetails;
